var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgReadAllNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 151,
    viewBox: "0 0 153 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 76.5,
    cy: 75.5,
    r: 70,
    stroke: "#C9FAC5",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 76.5,
    cy: 75.5,
    r: 75,
    stroke: "#C9FAC5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#C9FAC5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 75C16 41.8629 42.8629 15 76 15C109.137 15 136 41.8629 136 75C136 108.137 109.137 135 76 135C42.8629 135 16 108.137 16 75Z",
    fill: "#20B970"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5886 52.2023L70.5407 73.2503C68.9621 74.9604 66.1996 74.9604 64.621 73.2503L54.097 62.7263C52.3868 61.1477 52.3868 58.3852 54.097 56.8066C55.6756 55.0964 58.4381 55.0964 60.0167 56.8066L67.6466 64.3049L85.6689 46.2826C87.2475 44.5725 90.01 44.5725 91.5886 46.2826C93.2988 47.8612 93.2988 50.6237 91.5886 52.2023ZM104.217 69.0407L70.5407 102.717C68.9621 104.428 66.1996 104.428 64.621 102.717L47.7826 85.879C46.0725 84.3004 46.0725 81.5379 47.7826 79.9593C49.3612 78.2492 52.1237 78.2492 53.7023 79.9593L67.6466 93.772L98.2977 63.121C99.8763 61.4108 102.639 61.4108 104.217 63.121C105.928 64.6996 105.928 67.4621 104.217 69.0407Z",
    fill: "url(#paint0_linear_11801_422252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11801_422252",
    x1: 76,
    y1: 45,
    x2: 76,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFFE0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgReadAllNotification);
export default __webpack_public_path__ + "static/media/img_read_all_notification.9f3a2d22a0ee5a49a654e6216e558a4b.svg";
export { ForwardRef as ReactComponent };